
export default {
  props: {
    price: {
      type: Object,
      default: () => {
        return {
          price: 69,
          text: "La base pour être visible sur le web.",
          engagement: "sans engagement",
        };
      },
    },
    isStarter: {
      type: Boolean,
      default: false,
    },

    isBtnPrices: {
      type: Boolean,
      default: true,
    },

    isPerMonth: {
      type: Boolean,
      default: true,
    },

    surtitle: {
      type: String,
      default: "À partir de",
    },

    isColumned: {
      type: Boolean,
      default: false,
    },

    showAddon: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    isMask: false,
  }),

  mounted() {
    this.lazyMask();
  },

  methods: {
    lazyMask() {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.isMask = true;
            io.unobserve(entry.target);
          }
        });
      });

      io.observe(this.$refs.component);
    },
  },
};
